/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import { Icon } from '@iconify/react';
import { Fragment } from 'react';


const ReferralListInMissions = ({ userReferrals, handleCopyToClipboard, formatRelativeTime }) => {
  return (
    <Fragment>
      <div className="flex flex-row items-stretch justify-start w-full px-4 xl:px-8 mb-2 gothamBook">
        <div className="text-white text-xs xl:text-sm gothamMedium flex flex-1 items-center mr-1">UID</div>
        <div className="text-white text-xs xl:text-sm gothamMedium flex flex-1 items-center mr-1">Signed Up</div>
        {/**
         * 
        <div className="text-white text-xs xl:text-sm gothamMedium flex flex-1 items-center mr-1">MXS Gold</div>
         */}
        <div className="text-white text-xs xl:text-sm gothamMedium hidden sm:flex flex-1 items-center mr-1">Is Active</div>
    {/*
            <div className="text-white text-xs xl:text-sm gothamMedium hidden lg:flex flex-1 items-center mr-1">Game Played</div>
        <div className="text-white text-xs xl:text-sm gothamMedium hidden lg:flex flex-1 items-center">Mission Done</div>
    */}
      </div>
      <Fragment>
      {userReferrals !== null && userReferrals && userReferrals.length > 0 ? (
        userReferrals.map((referred_user, i) => (
          <div key={i} className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-4 xl:px-8 py-4 mb-4 gothamBook">
            <div className="flex flex-row justify-start items-center flex-1 text-xs xl:text-sm mr-1">
              <span className="mr-2">{referred_user.uid.substring(0, 3) + "..." + referred_user.uid.substring(referred_user.uid.length - 3)}</span>
              <button onClick={() => handleCopyToClipboard(referred_user.uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400">
                <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
              </button>
            </div>
            <div className="flex items-center flex-1 text-xs xl:text-sm mr-1">{formatRelativeTime(referred_user.timestamp_dt)}</div>
            {/*
            
            <div className="flex items-center flex-1 text-xs xl:text-sm mr-1">
              {referred_user.all_time_mxs_gold_with_bonuses} 
              <Image src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png" className="w-5 h-5 ml-2" alt="MXS GOLD" width={200} height={200} />
            </div>
            */}
            <div className="hidden sm:flex items-center flex-1 text-xs xl:text-sm mr-1">
              {referred_user.is_active ? <Icon icon="flat-color-icons:ok" className="w-5 h-5 ml-2" /> : <Icon icon="twemoji:cross-mark" className="w-4 h-4 ml-2" />}
            </div>
            {/*

            <span className="hidden lg:flex items-center flex-1 text-xs xl:text-sm mr-1">
              {referred_user.no_of_games_played}
              {referred_user.no_of_games_played > 0 ? <Icon icon="flat-color-icons:ok" className="w-5 h-5 ml-2" /> : <Icon icon="twemoji:cross-mark" className="w-4 h-4 ml-2" />}
            </span>
            <span className="hidden lg:flex items-center flex-1 text-xs xl:text-sm">
              {referred_user.no_of_missions_completed}
              {referred_user.no_of_missions_completed > 0 ? <Icon icon="flat-color-icons:ok" className="w-5 h-5 ml-2" /> : <Icon icon="twemoji:cross-mark" className="w-4 h-4 ml-2" />}
            </span>
            */}

          </div>
        ))
      ) : (
        <div className="flex items-center justify-center bg-metaxseed-content-gray rounded-xl px-4 py-4 my-4">
          <span className="text-metaxseed-light-gray">No referred users found</span>
        </div>
      )}
      </Fragment>
    </Fragment>
  );
};

export default ReferralListInMissions;